import React, { useState, useEffect } from 'react';
import { Container, Header, Image, Segment, Icon } from 'semantic-ui-react';
import Slider from 'react-slick';
import '@styles/BlogBody.css';

const visionData = [
  {
    title: 'Technology',
    description: 'Utilizing cutting-edge technology, with a strong focus on Salesforce, to enhance customer experiences by respecting their journeys and steering clear of practices that nudge towards idle distractions',
    image: '/assets/FeedItems/BBW9wYFE5aKngj2p85C.svg',
    icon: 'cloud'
  },
  {
    title: 'History',
    description: 'History is a mosaic, assembled by the storytellers of the ages, illustrating the power of narrative to spark imagination.',
    image: '/assets/FeedItems/BBMw8pKuh48JGTeTQGB.svg',
    icon: 'university'
  },
  {
    title: 'Mindfulness',
    description: 'Our mission is to integrate mindfulness in our technology, we aim to cultivate balance and focus, empowering users to engage thoughtfully and intentionally with everything we create.',
    image: '/assets/FeedItems/BBpdRypWZy3FZA3U22Z.svg',
    icon: 'leaf'
  },
];

const Vision = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for vision page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'Vision - Cloud CZR | Technology, History & Mindfulness';
    updateMetaTag('og:title', 'Vision - Cloud CZR | Technology, History & Mindfulness');
    updateMetaTag('og:description', 'Our vision integrates cutting-edge technology, historical wisdom, and mindfulness practices to enhance customer experiences and empower thoughtful engagement.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Our vision integrates cutting-edge technology, historical wisdom, and mindfulness practices to enhance customer experiences and empower thoughtful engagement.', false);
    updateMetaTag('twitter:title', 'Vision - Cloud CZR | Technology, History & Mindfulness', false);
    updateMetaTag('twitter:description', 'Our vision integrates cutting-edge technology, historical wisdom, and mindfulness practices to enhance customer experiences and empower thoughtful engagement.', false);
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
  };

  return (
    <Container style={{ marginTop: '2em' }} class="blog-body">
      <Header as='h1' textAlign='center' icon style={{ color: '#a9885c' }}>
        <Icon name='dna' style={{ color: '#a9885c' }}/>
        <Image src={`${process.env.PUBLIC_URL}/assets/vision.svg`} alt="Cloud CZR, Cloudczr, cloudczr.com" style={{ width: isDesktop ? '40%' : '100%', height: 'auto', margin: '0 auto 15px auto', display: 'block' }} />
      </Header>

      <Slider {...settings}>
        {visionData.map((item, index) => (
          <Segment key={index} padded textAlign='center'>
            <Icon name={item.icon} size='huge' style={{ color: '#a9885c' }}/>
            <Header as='h2' style={{ color: '#a9885c' }}>{item.title}</Header>
            <span class="imageExpand"> <Image src={item.image} alt="Cloud CZR, Cloudczr, cloudczr.com" size='medium' centered rounded /></span>
            <p style={{ marginTop: '1em', fontSize: '1.2em',  padding: '0 2em', color: '#a9885c' }}>
              {item.description}
            </p>
          </Segment>
        ))}
      </Slider>
    </Container>
  );
};

export default Vision;
